<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <Listbox as="div" v-model="selected" @click="update" class="" :disabled="disabled">
    <ListboxLabel class="block text-sm text-gray-700">{{label}} {{  }}</ListboxLabel>
    <div class=" relative">
      <ListboxButton class="relative w-full border border-gray-200 rounded-md pl-3 pr-8 py-1.5 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 text-xs" :class="disabled ? 'bg-[#EEE]' : 'bg-white'">
        <span class="block truncate flex items-center">
            <div v-if="selected.icon" class="pr-2 flex items-center">
              <component :is="selected.icon" class="inline-block h-4 w-4 " :class="selected.colorIcon" aria-hidden="true" />
            </div>
            <div v-if="selected.color" class="pr-2 flex items-center">
              <span class="inline-flex h-2.5 w-2.5 rounded-full opacity-75" :class="selected.color" :style="{ backgroundColor: selected.color }"/>
            </div>
            {{ selected.name }}
        </span>
        <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ArrowsUpDownIcon class="h-4 w-4 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>

      <transition :class="showOnTop ? 'mb-1 bottom-full' : ''" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <ListboxOptions class="absolute z-10 mt-1 w-full bg-white shadow-md max-h-60 rounded-md py-1 text-xs ring-1 ring-gray-200 overflow-auto focus:outline-none">
          <ListboxOption as="template" v-for="item in data" :key="item.name" :value="item" >
            <li :class="[item.selected ? 'text-white bg-slate-600' : 'text-gray-900 hover:bg-gray-50', 'cursor-default select-none relative py-1.5 pl-3 pr-8 text-xs']">
              <span class="flex items-center" :class="[item.selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                <div v-if="item.icon" class="pr-2 flex items-center">
                  <component :is="item.icon" class="inline-block h-4 w-4 " :class="item.colorIcon" aria-hidden="true" />
                </div>
                <div v-if="item.color" class="pr-2 flex items-center">
                  <span class="inline-flex h-2.5 w-2.5 rounded-full opacity-75" :class="item.color" :style="{ backgroundColor: item.color }"/>
                </div>
                {{ item.name }}
              </span>
              <span v-if="item.selected" class="text-white absolute inset-y-0 right-0 flex items-center pr-3">
                <CheckIcon class="h-4 w-4" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions, } from "@headlessui/vue";
import { CheckIcon, ArrowsUpDownIcon } from "@heroicons/vue/24/solid";

export default {
    name: "FormFildDropDown",
    props: {
        label: String,
        data: Array,
        value: [String, Object, Boolean, Number],
        disabled: Boolean,
        showOnTop: Boolean,
    },
    data() {
        return {          
          selected: {},  
        };
    },
    methods: {
        
        update(){          

          for(let i = 0; i < this.data.length; i++){
            if(this.data[i].value == this.value){
              this.data[i].selected = true;
            }
            else{
              this.data[i].selected = false;
            }
          }              
            
          
          this.$emit('update:modelValue', this.selected.value);
        },        
    },
    components: {
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CheckIcon,
        ArrowsUpDownIcon,
    },
    created() {

      // Existing value
      if(!this.value){
        this.data[0].selected = true;                
        this.selected = this.data[0];        
      }
      else {
        for(let i = 0; i < this.data.length; i++){
          if(this.data[i].value == this.value){
            this.data[i].selected = true;
            this.selected = this.data[i];
          }
          else{
            this.data[i].selected = false;
          }          
        }    
      }

    },
    watch: {
      value(newValue) {
        for(let i = 0; i < this.data.length; i++){
          if(this.data[i].value == newValue){
            this.data[i].selected = true;
            this.selected = this.data[i];
          }
          else{
            this.data[i].selected = false;
          }          
        }    
      },
    },
    mounted() {

      setTimeout(() => {
        this.update();
      }, 150);

    },
};
</script>